import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Flex, Image, Text } from '@chakra-ui/react'
import React from 'react'
import img from '../../../assets/images/pin_warning.png'

function PinWarning({ cancelRef, onClose, isOpen }) {
    return (
        <AlertDialog motionPreset='slideInBottom' leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered >
            <AlertDialogOverlay />
            <AlertDialogContent>
                <AlertDialogBody>
                    <Flex mt={8} mx={16} mb={4} justifyContent='center'>
                        <Image src={img} />
                    </Flex>
                    <Text textAlign='center' fontWeight={600} >Jumlah item yang di pin melebihi batas</Text>
                    <Text textAlign='center' fontWeight={600} >Silahkan unpin terlebih dahulu</Text>
                    <Flex mb={8} mt={4} justifyContent='center'>
                        <Button width='50%' ref={cancelRef} onClick={onClose} colorScheme='teal' >Ok</Button>
                    </Flex>
                </AlertDialogBody>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export default PinWarning